




























import { Vue, Component, Prop } from 'vue-property-decorator';
import Title from '@/components/utils/Title.vue';
import Button from '@/components/utils/Button.vue';
import Checkbox from '@/components/extractData/Checkbox.vue';

@Component({
  components: {
    Title,
    Button,
    Checkbox,
  },
})
export default class ExtractData extends Vue {
  title: Object = {
    label: 'Extraction comptes utilisateurs',
    description: 'Cher administrateur, vous pouvez extraire ici les données de vos utilisateurs. ',
  };

  adLabel: String =
    'cochez cette case pour extraire uniquement les données des utilisateurs ayant acceptés de recevoir des communications commerciale de la part de la Prévention MAIF';

  checkedParams: Array<any> = [];

  async mounted() {
    await this.$store.dispatch('account/a_init_Account', false);
  }

  checkboxChanged(event: any): void {
    if (event.value) {
      this.checkedParams.push(event.name);
    } else {
      const index = this.checkedParams.indexOf(event.name);
      if (index !== -1) {
        this.checkedParams.splice(index, 1);
      }
    }
  }

  async downloadCSVFile(event: any): Promise<any> {
    await this.$store
      .dispatch('account/a_get_extract', { params: this.checkedParams.join('&') })
      .then((response: any) => {
        console.info(response);
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
